import React, { useEffect, useState } from "react";
import CheckSDKUserFormService from "../services/UserCheckService";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import UserAgreement from "../component/UserAgreement";
import { useTranslation } from "react-i18next";
import { API_JAVA } from "../config";
import ErrorModal from "../component/ErrorModal";

const getUserCheckErrorKey = (error, type) => {
  const responseData = error.response?.data;
  const responseMessage =
    typeof responseData === "string"
      ? responseData
      : responseData?.detail;

  if (
    typeof responseMessage === "string" &&
    responseMessage.startsWith("error.")
  ) {
    return responseMessage;
  }

  if (!error.response || error.response.status >= 500) {
    return "error.gbdServiceUnavailable";
  }

  if (error.response.status === 404) {
    return type === "ul"
      ? "error.userBinNotFoundError"
      : "error.userNotFoundError";
  }

  return "error.defaultError";
};


const UserCheck = () => {
  const { state, search } = useLocation();
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(search);
  const queryType = searchParams.get("type");
  const isSdkFlow = searchParams.get("flow") === "sdk";
  const type = queryType === "fl" || queryType === "ul"
    ? queryType
    : state?.type || "ul";
  const navigationPath = isSdkFlow
    ? "/sdk-form"
    : state?.navigationPath || "/nm-user-form";
  const titleKey = isSdkFlow
    ? "SDKUserForm.titleRegistration"
    : state?.titleKey || "NCALayerModuleForm.title";
  const [captcha, setCaptcha] = useState("");
  const [captchaKey, setCaptchaKey] = useState("");
  const [bin, setBin] = useState("");
  const [iin, setIin] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const [captchaImage, setCaptchaImage] = useState("");
  const [isPopupVisible, setPopupVisibility] = useState(true);
  
  //   const type = "ul";

  useEffect(() => {
    axios
      .get(`${API_JAVA}/sdk-user/generateCaptcha`)
      .then((response) => {
        const captchaKey = response.data.captchaKey;
        const captchaImage = response.data.image;
        setCaptchaKey(captchaKey);
        setCaptchaImage(captchaImage);
        setCaptcha("");

        // setPopupVisibility(true);
      })
      .catch((error) => {
        console.error("Ошибка на стороне сервера:", error);
        navigate("/error", {
          state: { replace: true, error: t("error.captchaError") },
        });
      });
  }, []);

  const handleCheckBin = async (e) => {
    e.preventDefault();
    setErrorMessage(null);
    const iinOrBinRegex = /^\d{12}$/;
    if(type === "ul") {
      if (!iinOrBinRegex.test(iin) || !iinOrBinRegex.test(bin)) {
        setErrorMessage("error.correctInputError");
        return;
      }
    } else if(type === "fl") {
      if (!iinOrBinRegex.test(iin)) {
        setErrorMessage("error.correctInputError");
        return;
      }
    }
    
    try {
      console.log("Запрос отправлен...");
      const response = await CheckSDKUserFormService.userCheck(captcha, captchaKey, bin, iin, type);
      console.log("Ответ получен:", response);
  
      if (response && response.data) {
          const validatedBIN = response.data.checkedGbdUlUser ? response.data.checkedGbdUlUser.bin : null;
          const validatedOrganizationName = response.data.checkedGbdUlUser ? response.data.checkedGbdUlUser.organizationName : null;
          const validatedIIN = response.data.iin;
  
          navigate(navigationPath, {
              replace: true,
              state: { validatedBIN, validatedOrganizationName, validatedIIN },
          });
      } else {
          console.error("Некорректный формат ответа от сервера");
      }
        } catch (error) {
        console.error("Ошибка проверки пользователя:", error);
        setErrorMessage(getUserCheckErrorKey(error, type));
    

      axios
        .get(`${API_JAVA}/sdk-user/generateCaptcha`)
        .then((response) => {
          const captchaKey = response.data.captchaKey;
          const captchaImage = response.data.image;
          setCaptchaKey(captchaKey);
          setCaptchaImage(captchaImage);
          setCaptcha("");
        })
        .catch((error) => {
          console.error("Ошибка при получении изображения CAPTCHA:", error);
        });
    }
  };
  const handleClosePopup = () => {
    setPopupVisibility(false);
  };

  return (
    
    <div className="content">
      {isPopupVisible && (
        <div>
          <div className="overlay"></div>
          <div className="popup-content">
            <UserAgreement onClose={handleClosePopup} />
          </div>
        </div>
      )}
      <div className="titleCell">
        <span>{t(titleKey)}</span>
      </div>

      <form id="indexForm" className="indexForm" onSubmit={handleCheckBin}>
        <div className="vktHeaderDiv">{t("SDKUserForm.formTitle")}</div>
        {errorMessage && <ErrorModal errorMessage={errorMessage} />}
        <table cellPadding="8" style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td className="ccLeft width-255">
                <span style={{ verticalAlign: "middle" }}>
                  {t("SDKUserForm.captchaText")}:
                  <span style={{ color: "red" }}> *</span>
                </span>
              </td>
              <td className="ccRight width-525">
                <input
                  id="captcha"
                  name="captcha"
                  type="text"
                  maxLength="5"
                  className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 no-disable-field"
                  role="textbox"
                  aria-disabled="false"
                  aria-readonly="false"
                  value={captcha}
                  onChange={(e) => setCaptcha(e.target.value)}
                />
              </td>
              <td className="ccRight">
                <span id="captchaImage">
                  <img
                    src={`data:image/png;base64,${captchaImage}`}
                    alt="Captcha"
                  />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        {type === "ul" && (
          <table id="rcfield" cellPadding={0} style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <table cellPadding="8" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td
                          className="ccLeft width-255"
                          style={{ width: "236.91px" }}
                        >
                          <span id="rcfield:0:labels">
                            {t("SDKUserForm.bin")}:
                            <span style={{ color: "red" }}> *</span>
                          </span>
                        </td>
                        <td className="ccRight width-525">
                          <span id="rcfield:0:values">
                            <input
                              id="rcfield:0:inputValue"
                              name="rcfield:0:inputValue"
                              type="text"
                              maxLength="12"
                              className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin no-disable-field"
                              role="textbox"
                              aria-disabled="false"
                              aria-readonly="false"
                              placeholder="348951276584"
                              value={bin}
                              onChange={(e) => setBin(e.target.value)}
                            />
                          </span>
                        </td>
                        <td className="ccRight"></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        <table id="rcfield" cellPadding={0} style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td
                        className="ccLeft width-255"
                        style={{ width: "236.91px" }}
                      >
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.iin")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="12"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin no-disable-field"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder="348951276584"
                            value={iin}
                            onChange={(e) => setIin(e.target.value)}
                          />
                        </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:0:additionals">
                          <button
                            id="rcfield:0:checkCompanyButton"
                            name="rcfield:0:checkCompanyButton"
                            className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only new-blue-btn"
                            type="submit"
                            role="button"
                            aria-disabled="false"
                          >
                            <span className="ui-button-text ui-c">
                              {t("SDKUserForm.check")}
                            </span>
                          </button>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  );
};

export default UserCheck;
